import { render, staticRenderFns } from "./VehicleInfoCompatibilityTable.vue?vue&type=template&id=5fcd4a53"
import script from "./VehicleInfoCompatibilityTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleInfoCompatibilityTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports